import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthConstants } from '../constants/auth';
import { HttpService } from './http.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public data : any = {};

	constructor(
		private httpService: HttpService,
		private storageService: StorageService,
		private router: Router
	) {}
	
	fetch() {
		return this.httpService.get('contact/me');
	}

	setData() {
		this.fetch().subscribe((res: any) => {
			this.data = res.result;
		});
	}

	get() {
		return this.data;
	}

	login(form: any): Observable<any> {

		let headers = {
            headers: {
                'X-BS-Auth-Login': form.email,
                'X-BS-Auth-Password': form.password
            }
        };

		return this.httpService.get('auth', headers);
	}
	
	signup(form: any): Observable<any> {
		return this.httpService.post('register', form);
	}

	update(params?:any) {
		this.httpService.put('contact/'+this.data.id, params).subscribe((response:any)=>{},(err) => {});
	}
	
	logout() {
		this.clear();
		this.router.navigate(['/login'], {replaceUrl: true});
	}

	clear() {
		this.storageService.removeStorageItem(AuthConstants.TOKEN);
		this.storageService.clear();
	}
}
